'use strict';

const headerMenu = {
	init: function() {
		this.detailsEvents();
		this.burgerEvents();
	},

	detailsEvents : function(){
		let details = document.querySelectorAll('.headerMain__container__nav details');
		if( details ){
			details.forEach(detailsItem => {
				detailsItem.addEventListener('toggle', headerMenu.closeOtherDetails);
			});
		}
	},

	closeOtherDetails : function(e){
		let currentItem = e.target;
		let currentList = currentItem.closest("ul");
		if( currentItem.open && currentList ){
			let openDetails = currentList.querySelectorAll(":scope > li.has-children > details");
			if( openDetails ){
				openDetails.forEach(openDetailsItem => {
					if( openDetailsItem != currentItem ){
						openDetailsItem.open = false;
					}
				})
			}
		}
	},

	burgerEvents : function(){
		let burger = document.getElementById('burger');
		if( burger ){
			burger.addEventListener('click', headerMenu.toggleMobileMenu);
		}
	},

	toggleMobileMenu : function(e){
		let header = document.querySelector('header');
		if( header ){
			header.classList.toggle('mobileMenuOpen');
		}
	}
}

export default headerMenu;